// Server-side API URL: uses localhost to avoid Cloudflare round-trip + ETIMEDOUT issues during SSR.
// API_URL (runtime, server-only) > NEXT_PUBLIC_API_URL (build-time, both) > fallback
export const SERVER_API_URL = process.env.API_URL || process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3001/api';

/**
 * fetch mot API:t med ett omförsök vid avbruten anslutning. När API:t laddas om
 * (pm2 reload i klusterläge) kan ett anrop hamna på en ledig anslutning som just
 * stängs — "other side closed" / ECONNRESET. Utan omförsök blev det "Failed to
 * fetch category data" och 404 på kategorisidan (84 gånger 2026-09-26).
 */
export async function hamtaApi(url: string, init?: RequestInit & { next?: { revalidate?: number | false; tags?: string[] } }): Promise<Response> {
  try {
    return await fetch(url, init);
  } catch (e) {
    const orsak = (e as { cause?: { code?: string; name?: string } })?.cause;
    const avbruten = e instanceof TypeError && (orsak?.code === 'ECONNRESET' || orsak?.code === 'UND_ERR_SOCKET'
      || orsak?.name === 'SocketError' || orsak?.code === 'ECONNREFUSED');
    if (!avbruten || (init?.method && init.method !== 'GET')) throw e;
    await new Promise((r) => setTimeout(r, 250));
    return fetch(url, init);
  }
}
